module.exports = __webpack_public_path__ + "img/avartaravartar.cd696695.png";